import { ReactNode } from "react"

export const Modal = ({ children }: { children: ReactNode }) => {
    return (
        <div className='z-[100000000000] flex flex-col items-center justify-center h-[100%] w-[100%] bg-[#000000B2] fixed top-0 left-0 right-0 bottom-0'>
            {children}
        </div>
    )
}